module.exports = __webpack_public_path__ + "static/media/copy-icon-naivy.91078f25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/copy-icon-naivy.svg
// module id = 278
// module chunks = 0